import React from 'react';
//import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { /*alpha,*/ makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import FolderOutlined from '@material-ui/icons/FolderOutlined';
import Typography from '@material-ui/core/Typography';
//import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}
/*
function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  // Show the component; triggers the enter or exit states
  in: PropTypes.bool,
};
*/

/*
const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    //borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    borderLeft: `1px dashed rgb(80 80 80 / 0.6)`,
  },
//}))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);
}))((props) => <TreeItem {...props}  />);
*/




const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    //color: theme.palette.text.secondary,
    /*'&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },*/
    /*'&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },*/
    /*'&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },*/
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed rgb(80 80 80 / 0.6)`,
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1
  },
}));


function StyledTreeItem(props) {

  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

  return (
    <TreeItem
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
  );
}



const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: "99%",
  },
});



// Функция для создания дерева из плоского списка
const buildTree = ( list ) => {
 
    if( !Array.isArray( list ) ) return [ [], [] ];
   
    const map = {};
    const roots = [];
    const expanded = [];

    // Создание хэша id -> item
    list.forEach( i => {
        // i.id = i.type + i.id; // G123 или F123 для группы и формы, потому что id групп и форм могут пересекаться
        
        map[ i.tyid ] = { ...i, children: [] };
        expanded.push( i.tyid );
    });

    // Заполнение children и определение корневых элементов
    list.forEach( i => {
        if( i.parent_id === null || i.parent_id === undefined )
            roots.push( map[ i.tyid ] );
        else
            map[ "G" + i.parent_id ]?.children.push( map[ i.tyid ] );
    });

    return [ roots, expanded ];
};

// Рекурсивное создание компонентов TreeItem
const renderTree = ( i ) => (
    <StyledTreeItem key={ i.tyid } nodeId={ i.tyid } labelText={ i.name } labelIcon={ i.type === "F" ? DescriptionOutlined : FolderOutlined }>
        {Array.isArray( i.children )
            ? i.children.map( renderTree )
            : null}
    </StyledTreeItem>
);



export default function Tree( props ) {
  
  const classes = useStyles();
  
  const [ roots, expanded ] = buildTree( props.doc.formTree );
  const tree = roots.map( renderTree );

  return (
  
    <TreeView
        className = { classes.root }
        expanded = { expanded }
        defaultCollapseIcon = { <MinusSquare /> }
        defaultExpandIcon = { <PlusSquare /> }
        //defaultEndIcon = { <CloseSquare /> }
        onNodeSelect = { props.onNodeSelect }
    >
    { tree }
    </TreeView>


  );
}
